<template>
  <div>
    <div class="inquiries-layout__header">
      <div class="inquiries-layout__header-inner">
        <h1>エラー</h1>
      </div>
    </div>
    <p class="inquiries-layout__lead">
      申し訳ありませんが、最初からもう一度操作を繰り返してください。
    </p>
    <div class="inquiries">
      <div class="inquiries__bottom-wrapper--primary">
        <ButtonLink
          class="inquiries__button"
          type="to"
          :href="NTT_BUSINESS_TOP_URL"
          >NTT東日本 法人のお客様トップへ</ButtonLink
        >
      </div>
    </div>
  </div>
</template>
<script>
import ButtonLink from "@/components/button/Link";
import "@/assets/shared/sass/object/project/_inquiries.scss";

export default {
  head: {
    title: {
      inner: "システムエラー",
      separator: "|",
      complement: "NTT東日本",
    },
    meta: [
      { property: "og:title", content: "システムエラー | NTT東日本" },
      { name: "twitter:title", content: "システムエラー | NTT東日本" },
    ],
    link: [
      {
        rel: "canonical",
        href: "https://form.business.ntt-east.co.jp/error-system",
        id: "canonical",
      },
    ],
  },
  name: "ErrorSystem",
  props: ["type"],
  components: {
    ButtonLink,
  },
  data: function () {
    return {
      NTT_BUSINESS_TOP_URL: process.env.VUE_APP_NTT_BUSINESS_TOP_URL,
    };
  },
};
</script>

<style lang="scss" scoped>
.inquiries-layout__lead {
  margin-bottom: 32px;
}
.inquiries__button {
  width: 300px;
  height: 50px;
  .button-link__body {
    font-weight: normal;
  }
}
</style>
